import axios from 'axios'

export const apiAxios = axios.create({
  baseURL: process.env.VUE_APP_SIRV_API_URL
})
